import { HStack, Text, VStack } from '@chakra-ui/react'
import {
  Blur,
  BlurOff,
  Mic,
  MicOff,
  VideoCamera,
  VideoCameraOff
} from '@components/icons'
import {
  useAudioTrack,
  useDaily,
  useLocalSessionId,
  useVideoTrack
} from '@daily-co/daily-react'
import React from 'react'
import { isMobile } from 'react-device-detect'
import { useActiveTelehealthSession } from '../context/active-telehealth-session.context'

export const SettingsActionBar = () => {
  const daily = useDaily()
  const localId = useLocalSessionId()
  const camTrack = useVideoTrack(localId)
  const micTrack = useAudioTrack(localId)
  const { isBackgroundBlurred, toggleBackgroundBlur } =
    useActiveTelehealthSession()

  const handleToggleMic = () => {
    daily?.setLocalAudio(micTrack.isOff)
  }

  const handleToggleCam = () => {
    daily?.setLocalVideo(camTrack.isOff)
  }

  const MicIcon = micTrack.isOff ? (
    <MicOff width="24px" />
  ) : (
    <Mic width="24px" />
  )

  const CamIcon = camTrack.isOff ? (
    <VideoCameraOff width="24px" />
  ) : (
    <VideoCamera width="24px" />
  )

  const BlurIcon = isBackgroundBlurred ? <Blur /> : <BlurOff />

  return (
    <HStack justify="center" h="54px" gap="16px">
      <VStack
        _hover={{ cursor: 'pointer' }}
        onClick={handleToggleCam}
        w="54px"
        data-click-text={camTrack.isOff ? 'Turn on camera' : 'Turn off camera'}
      >
        {CamIcon}
        <Text fontSize="10px" style={{ marginTop: 0 }}>
          {camTrack.isOff ? 'Turn on' : 'Turn off'}
        </Text>
      </VStack>
      <VStack
        _hover={{ cursor: 'pointer' }}
        onClick={handleToggleMic}
        w="41px"
        data-click-text={
          micTrack.isOff ? 'Unmute microphone' : 'Mute microphone'
        }
      >
        {MicIcon}
        <Text fontSize="10px" style={{ marginTop: 0 }}>
          {micTrack.isOff ? 'Unmute' : 'Mute'}
        </Text>
      </VStack>
      {!isMobile && (
        <VStack
          _hover={{ cursor: 'pointer' }}
          onClick={toggleBackgroundBlur}
          w="41px"
          data-click-text={
            isBackgroundBlurred
              ? 'Turn off background blur'
              : 'Turn on background blur'
          }
        >
          {BlurIcon}
          <Text fontSize="10px" style={{ marginTop: 0 }}>
            {isBackgroundBlurred ? 'Blur off' : 'Blur on'}
          </Text>
        </VStack>
      )}
    </HStack>
  )
}
